const ModuleHeader = () => {
  return (
    <div className="header">
      <h2>Cor Sound</h2>
    </div>
  );
};

export default ModuleHeader;
